// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__ILglz","mblogo":"Header_mblogo__Yw3Q4"};